import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolderAddLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"folder-add-left"} maskId="square-filled-radius-0-stroke-1-IconFolderAddLeft"><path d="M10.2676 3H2V16H3V13H6V16H9V19H6V20H22V6H12.2676L10.2676 3Z" fill="currentColor"/><path d="M5 17V14H4V17H1V18H4V21H5V18H8V17H5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFolderAddLeft;
